import Vue from 'vue';
import notificationService from '@mobile/services/notification';
import { userToken } from '@mobile/services/user';

export default {
    namespaced: true,

    state: getDefaultState(),

    getters: {
        unread_count: (state) => state.unreadCount,
        all: (state) => state.all,
        has_prev_page: (state) => (!!state.prev_page_url),
        has_next_page: (state) => (!!state.next_page_url),
        loading: (state) => state.loading,
    },
    actions: {
        async query({ state, commit }, payload = {}) {
            commit('startLoading');

            const response = await notificationService.getAll(payload.url, payload.filters);

            if (!payload.url) {
                state.all = [];
            }
            state.all = state.all.concat(response.resources);

            state.prev_page_url = response.prev_page_url;
            state.next_page_url = response.next_page_url;

            state.loading = false;

        },
        async loadMore({ state, dispatch }, payload) {
            dispatch('query', { url: state.next_page_url, filters: payload.filters });
        },
        async unreadCount({ state }) {
            if (!userToken()) {
                return;
            }
            const response = await notificationService.getUnreadCount();

            if (response) {
                state.unreadCount = response.count;
            } else {
                state.unreadCount = 0;
            }
        },
        async changeStatusToRead({ state, dispatch, commit }, payload) {
            const response = await notificationService.changeStatusToRead(payload.notificationId);
            if (response) {
                commit('changeNotificationToRead', {
                    notificationId: payload.notificationId,
                    readAt: response.read_at,
                });
                dispatch('unreadCount');
            }
        },
    },
    mutations: {
        reset(state) {
            Object.assign(state, getDefaultState());
        },
        resetAll(state) {
            state.all = [];
        },

        startLoading(state) {
            state.loading = true;
        },
        changeNotificationToRead(state, { notificationId, readAt }) {
            for (let i = 0; i < state.all.length; i++) {
                if (state.all[i].id === notificationId) {
                    state.all[i].read_at = readAt;
                    break;
                }
            }
        },
    },
};

function getDefaultState() {
    return {
        unreadCount: 0,
        all: [],
        next_page_url: null,
        prev_page_url: null,
        loading: true,
    };
}
